import { observer } from "mobx-react-lite";
import { useState } from "react";

import { DateTime } from "@bps/date-time";
import { Card, DefaultButton, Stack } from "@bps/fluent-ui";

import { useIntegrationScreenContext } from "../context/IntegrationScreenContext.ts";
import { XeroSyncHistoryHeading } from "./XeroSyncHistoryHeading.tsx";
import { XeroSyncHistoryList } from "./XeroSyncHistoryList.tsx";

export const XeroSyncHistoryCard = observer(() => {
  const { xeroTenantId, showXeroConfigurationCard, xeroTenants } =
    useIntegrationScreenContext();

  const [refreshKey, setRefreshKey] = useState<string>("");
  const [showAll, setShowAll] = useState(false);

  const refreshList = () => {
    setRefreshKey(DateTime.now().toISO());
  };

  if (!xeroTenantId || !showXeroConfigurationCard || xeroTenants.length === 0)
    return null;

  return (
    <Card
      heading={<XeroSyncHistoryHeading />}
      styles={{
        heading: { width: "100%" },
        subComponentStyles: {
          tile: {
            content: { padding: 24 }
          }
        }
      }}
    >
      <Stack horizontal tokens={{ childrenGap: 20 }} horizontalAlign="end">
        <DefaultButton onClick={refreshList}>Refresh</DefaultButton>
        <DefaultButton
          onClick={() => {
            setShowAll(!showAll);
            refreshList();
          }}
        >
          {showAll ? "Show only errors" : "Show all"}
        </DefaultButton>
      </Stack>
      <XeroSyncHistoryList refreshKey={refreshKey} showAll={showAll} />
    </Card>
  );
});
